var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7305 2.34511L15.6547 0.269025C15.2929 -0.0925779 14.7075 -0.0919801 14.3459 0.269025L13 1.61494L16.3854 4.99982L17.7305 3.6533C18.0918 3.29173 18.0924 2.70611 17.7305 2.34511Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15295 13.4628L0 18.0014L4.53779 16.847L15.7684 5.61531L12.3841 2.23047L1.15295 13.4628ZM3.27545 14.2318L2.50643 13.4628L12.2915 3.67765L13.0611 4.44724L3.27545 14.2318Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditV2);
export default __webpack_public_path__ + "static/media/edit-v2.4fb484251f5792e504e6aabf4ad31cd3.svg";
export { ForwardRef as ReactComponent };